export default "__VITE_ASSET__BAjCCLHK__"